import React, { useEffect, useState, useRef } from 'react'
import { Formik } from 'formik'
import { SelectFieldIcon, TextAreaIcon, TextFieldIcon, Panel, FileFieldIcon, ModalComponent } from '../../_components';
import { FaBuilding } from 'react-icons/fa'
import { CircularProgress } from '@material-ui/core'
import Axios from 'axios'
import { handleFileChange } from '../../_utils'
import data from '../../fixtures'
import moment from 'moment'

export default function Actions( { result } ) {
    const ref = useRef(null);
    const [ comments, setComments ] = useState( [] )
    const [ loadingRemarks, setLoadingRemarks ] = useState( true )
    const [ auditReportFile, setAuditReportFile ] = useState( {} )
    const [ circularLoading, setCircularLoading ] = React.useState( false )
    const [ auditors, setAuditors ] = useState( [] )
    const [ files, setFiles ] = useState( [] )
    const [ showAuditReport, setShowAuditReport ] = useState( false )
    const [ auditReport, setAuditReport ] = useState( [] )
    const [ qa1Report, setQa1Report ] = useState( [] )
    const [ securityReport, setSecurityReport ] = useState( [] )
    const [ showSecurityClearanceReport, setShowSecurityClearanceReport ] = useState( false )
    const [ certificationFee, setCertificationFee ] = useState( [] )
    const [ servicesDropdown, setServicesDropdown ] = useState( [] )
    const [ auditeeMemberNames, setAuditeeMemberNames ] = useState( [{ auditee_members: "" }] )
    const [ skillsDropdown, setSkillsDropdown ] = useState( [] )
    const [ serviceNames, setServiceNames ] = useState( [{ service_name: "" }] )
    const [ skillNames, setSkillNames ] = useState( [{ service_name: "" }] )
    const [ incomeBand, setIncomeBand ] = useState( result?.annual_turnover )
    
    // If not a Company, certification fee is a flat 473,000
    React.useEffect(() => {
        if (result?.category && result?.category !== "Company") {
            setCertificationFee([0])
        }
    }, [ result?.category ])

    
    useEffect( () => {
        if( loadingRemarks ) {
            getITRemarks()
            fetchAllUsers()
            fetchAllDocuments()
            fetchAuditReport()
            fetchQA1Report()
            fetchSecurityReport()
            fetchIsicCodes()
            fetchSkillsCodes()
        }
    }, [ loadingRemarks ])

    const fetchSecurityReport = async () => {
        let applicationId = localStorage.getItem( "applicationId" )
        try {
          const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getSecurityReport/${applicationId}` )
          if( response.data ){
            setSecurityReport( response.data )
          }
        } catch (error) {}
    }

    const fetchIsicCodes = async (evt) => {
        try {
            const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/get_isic_codes`);
            const et_response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/get_et_isic_codes`);
    
            if (localStorage.getItem( "domain" ) === "ET") {
                if( et_response.data.message === "success" ) {
                    let isicCodes = et_response.data.db_records
                    let isicDbCodes = isicCodes.map((item) => {
                        return {
                        id: item.id,
                        label: `${item.class}: ${item.description}`,
                        value: item.class
                        }
                    }
                    );
                    setServicesDropdown(isicDbCodes)
                } else{
                    console.log("response returned error")
                }
            } else {
                if( response.data.message === "success" ) {
                    let isicCodes = response.data.db_records
                    let isicDbCodes = isicCodes.map((item) => {
                        return {
                        id: item.id,
                        label: `${item.class}: ${item.description}`,
                        value: item.class
                        }
                    }
                    );
                    setServicesDropdown(isicDbCodes)
                } else{
                    console.log("response returned error")
                }
            }
        } catch (error) {
          console.log(error)
        }
    }
    
    const fetchSkillsCodes = async (evt) => {
        try {
          const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/get_skills_codes`);
    
          if( response.data.message === "success" ) {
            let skillCodes = response.data.db_records
            let skillDbCodes = skillCodes.map((item) => {
              return {
                id: item.id,
                label: `${item.skill_code}: ${item.skill}`,
                value: item.skill_code
              }
            }
            );
            setSkillsDropdown(skillDbCodes)
          } else{
            console.log("response returned error")
          }
        } catch (error) {
          console.log(error)
        }
    }

    const handleAnnualTurnOverChange = async(evt) => {
        let income_band = evt.target.value
        setIncomeBand(income_band)
    }

    const handleInputs = ( evt, idx ) => {    
        const newServiceNames = [...serviceNames];
        newServiceNames[idx][evt.target.name] = evt.target.value;
        setServiceNames(newServiceNames);
    }
    
    const handleRemove = idx => {
        const list = [ ...serviceNames ]
        list.splice( idx, 1 )
        return setServiceNames( list )
    }
    
    const handleAddService = () => {
        if( serviceNames.length < 7 ) {
          return setServiceNames([...serviceNames, { service_name: "" }]); // add another input to the state
        }
        
        return alert( "You can not add more than 7 services" )
    }
    
    const handleSkillsInputs = ( evt, idx ) => {    
        const newSkillNames = [...skillNames];
        newSkillNames[idx][evt.target.name] = evt.target.value;
        console.log(newSkillNames)
        setSkillNames(newSkillNames);
    }
    
    const handleSkillsRemove = idx => {
        const list = [ ...skillNames ]
        list.splice( idx, 1 )
        return setSkillNames( list )
    }
    
    const handleAddSkills = () => {
        if( skillNames.length < 7 ) {
          return setSkillNames([...skillNames, { service_name: "" }]); // add another input to the state
        }
        
        return alert( "You can not add more than 7 skills" )
    }

    const handleAuditeeMemberInputs = ( evt, idx ) => {    
        const newAuditeeMemberNames = [...auditeeMemberNames];
        newAuditeeMemberNames[idx] = evt.target.value;
        console.log(newAuditeeMemberNames)
        setAuditeeMemberNames(newAuditeeMemberNames);
    }
    
    const handleAuditeeMemberRemove = idx => {
        const list = [ ...auditeeMemberNames ]
        list.splice( idx, 1 )
        return setAuditeeMemberNames( list )
    }
    
    const handleAddAuditeeMember = () => {
        if( auditeeMemberNames.length < 7 ) {
          return setAuditeeMemberNames([...auditeeMemberNames, { auditee_members: "" }]); // add another input to the state
        }
        
        return alert( "You can not add more than 7 skills" )
    }

    const numberWithCommas = (numberToFormat) => {
        return numberToFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const getITRemarks = async () => {
        try {
            const response = await Axios.post(process.env.REACT_APP_API_URL+`/api/auth/getITRemarks`, {
                id: result?.id
            } )
            if( response.data ) {
                let results = response.data.filter( item => {
                    if(!localStorage.getItem( "role" )?.toUpperCase().includes("VERIFIER") || !localStorage.getItem( "role" )?.toUpperCase().includes("QA1")){
                        return item.role?.toUpperCase() === localStorage.getItem( "email" )?.toUpperCase() && result.id === item.parentID
                    }
                })
                setComments(  results );
                setLoadingRemarks( false )
            }
        } catch (error) {
            
        }
    }

    const fetchAllUsers = async () => {
        try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcouser` ) 

            const results = response.data.records
                .filter( user => user.user_role !== "APPLICANT" )
                .map( ( result, index ) => {
                return {
                    id: result.id,
                    label: result.email_address+" ("+result.phone_number+")",
                    value: result.email
                }
            } )
            setAuditors( results )
        } catch (error) {
            alert( "Server error occurred." )
        }
    }

    const fetchAllDocuments = async () => {
        let applicationId = localStorage.getItem( "applicationId" )
        try {
          const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getApplicationFiles/${applicationId}` )
          if( response.data ){
            setFiles( response.data?.data )
          }
        } catch (error) {}
    }

    const previewFile = async (e) => {
        let file_id = e.target.id
    
        try {
          const email = btoa(localStorage.getItem( "email" )); // Base64 encode
          const url = process.env.REACT_APP_API_URL+`/api/auth/get_file_details/${file_id}/${email}`
          const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
          if (newWindow) newWindow.opener = null
        } catch (error) {}
    }

    const fetchAuditReport = async () => {
        let applicationId = localStorage.getItem( "applicationId" )
        try {
          const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getAuditReport/${applicationId}` )
          if( response.data ){
            setAuditReport( response.data )
          }
        } catch (error) {}
    }

    const fetchQA1Report = async () => {
        let applicationId = localStorage.getItem( "applicationId" )
        try {
          const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getQualityAssuranceReport/${applicationId}` )
          if( response.data ){
            setQa1Report( response.data )
          }
        } catch (error) {}
    }

    const handleFile = ( evt, tag ) => {
        handleFileChange( evt, tag, (response, file ) => {
            setAuditReportFile( {
                document: response,
                name: file.name,
                size: file.size,
                tag: tag,
                type: file.type
            })
        })
    }

    const handleDocumentsVerify  = async ( values ) => {
        await setCircularLoading( true )
        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
                id: result?.id,
                progress: 10,
                email_address: result?.created_by,
                task: "Verified",
                stage: values.action === "Pass" ? 2 : 1,
                actioned_by: values.actioned_by,
                comments: values.comments,
                action: values.action,
                verification_status: values.action === "Pass" ? "COMPLETED" : null,
                role: localStorage.getItem( "role" )
            } )

            if( response.data ) {
                alert( response.data.message )
                // await dispatch( setDisplayVerify( { 
                //   flag: false
                // } ))
                await setCircularLoading( false )
                await localStorage.setItem( "link", "dashboard" )
                return window.location.reload()
            }
        } catch (error) {}
    }


    const handleSchedule = async ( values ) => {
        await setCircularLoading( true )
        //schedule a meeting
        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
            id: result.id,
            scheduled_action: "PENDING",
            stage: 4,
            scheduled_date: values?.scheduled_date,
            audit_leader: values?.audit_leader,
            audit_phone: values?.audit_phone,
            audit_email: values?.audit_email,
            comments: values.comments,
            action: "PENDING",
            role: localStorage.getItem( "role" ),
            actioned_by: localStorage.getItem( "email" ),
            email_address: result?.email_address
            } )
            if( response.data ) {
                await setCircularLoading( false )
                alert( response.data.message )
                return window.location.reload()
            }
        } catch (error) {}

        //date confirmed
        if(  result?.scheduled_action === "DATE_CONFIRMED" ) { 
        //   try {
        //     const response = await Axios.post( `https://mis.nec.go.ug/api/auth/itcoverify`, {
        //       id: payload.id,
        //       scheduled_action: "COMPLETED",
        //       progress: parseInt( payload.progress ) + 20,
        //       stage: parseInt( payload.stage ) + 1
        //     } )
        //     if( response.data ) {
        //       dispatch( setAuditModal( { auditFlag: false, title: "" } ) )
        //       alert( response.data.message )
        //       return window.location.reload()
        //     }
        //   } catch (error) {}
        }
    }

    const handleAuditReport = async ( values ) => {
        await setCircularLoading( true )
        let savedFile = { 
            file: auditReportFile.document, 
            title: auditReportFile.name, 
            size: auditReportFile.size, 
            type: auditReportFile.type, 
        }
      
        let auditFile = Object.assign( {}, savedFile )

        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
                id: result.id,
                scheduled_action: "COMPLETED",
                progress: 20,
                stage: 5,
                comments: values.comments,
                audit_file: auditFile,
                actioned_by: localStorage.getItem( "username" ),
                type_of_audit: values.type_of_audit,
                service_name: result.category === "Company" ? serviceNames : skillNames,
                auditee_members: auditeeMemberNames,
                applicable_regulation: values.applicable_regulation,
                applicable_standard: values.applicable_standard,
                audit_site: values.audit_site,
                audit_date: values.audit_date,
                distribution_limitations_responsibilties: values.distribution_limitations_responsibilties,
                audit_criteria: values.audit_criteria,
                proof_of_legal_status: values.proof_of_legal_status,
                proof_of_legal_status_comment: values.proof_of_legal_status_comment,
                proof_of_registration: values.proof_of_registration,
                proof_of_registration_comment: values.proof_of_registration_comment,
                proof_of_office_location: values.proof_of_office_location,
                proof_of_office_location_comment: values.proof_of_office_location_comment,
                proof_of_it_personnel: values.proof_of_it_personnel,
                proof_of_it_personnel_comment: values.proof_of_it_personnel_comment,
                proof_of_manuals: values.proof_of_manuals,
                proof_of_manuals_comment: values.proof_of_manuals_comment,
                proof_of_past_services: values.proof_of_past_services,
                proof_of_past_services_comment: values.proof_of_past_services_comment,
                audit_notes: values.audit_notes,
                role: localStorage.getItem( "role" )
            } )
            if( response.data ) {
                await setCircularLoading( false )
                console.log(response.data)
                //   dispatch( setAuditModal( { auditFlag: false, title: "" } ) )
                alert( response.data.message )
                await localStorage.setItem( "link", "dashboard" )
                return window.location.reload()
            }
        } catch (error) {}
    }

    const handleFinance = async ( values ) => {
        // Validate that comments are provided
        if (!values.comments || values.comments.trim() === '') {
            alert('Please provide comments before submitting.')
            return
        }
        
        await setCircularLoading( true )
        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
                id: result.id,
                certification_fee: certificationFee,
                finance_annual_turnover: values.finance_annual_turnover,
                finance_review: "YES",
                stage: 3,
                comments: values.comments,
                role: localStorage.getItem( "role" ),
                actioned_by: localStorage.getItem( "email" ),
                email_address: result?.email_address
            })

            if( response.data ) {
                await setCircularLoading( false )
                alert( response.data.message )
                await localStorage.setItem( "link", "finance" )
                return window.location.reload()
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleSecurityClearanceForm = async ( values ) => {
        await setCircularLoading( true )
        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
                id: result.id,
                stage: 5,
                code_of_conduct: values.code_of_conduct,
                code_of_conduct_comment: values.code_of_conduct_comment,
                terms_of_conditions_of_agreement: values.terms_of_conditions_of_agreement,
                terms_of_conditions_of_agreement_comment: values.terms_of_conditions_of_agreement_comment,
                staff_confidentiality_and_non_disclosure: values.staff_confidentiality_and_non_disclosure,
                staff_confidentiality_and_non_disclosure_comment: values.staff_confidentiality_and_non_disclosure_comment,
                data_retention_mechanism: values.data_retention_mechanism,
                data_retention_mechanism_comment: values.data_retention_mechanism_comment,
                internal_information_security_awareness: values.internal_information_security_awareness,
                internal_information_security_awareness_comment: values.internal_information_security_awareness_comment,
                information_security_policy: values.information_security_policy,
                information_security_policy_comment: values.information_security_policy_comment,
                data_protection_and_privacy: values.data_protection_and_privacy,
                data_protection_and_privacy_comment: values.data_protection_and_privacy_comment,
                action: values.action,
                security_clearance_update: true,
                role: localStorage.getItem( "role" ),
                actioned_by: localStorage.getItem( "email" ),
                email_address: result?.email_address
            })

            if( response.data ) {
                await setCircularLoading( false )
                alert( response.data.message )
                await localStorage.setItem( "link", "dashboard" )
                return window.location.reload()
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleQAA = async ( values ) => {
        // Validate that comments are provided
        if (!values.comments || values.comments.trim() === '') {
            alert('Please provide comments before submitting.')
            return
        }
        await setCircularLoading( true )
        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
                id: result.id,
                deferred_to_level: values.deferred_to_level,
                qa_level1_action: localStorage.getItem( "role" )?.toUpperCase().includes("QA1") && values.action,
                qa_level1_comments: localStorage.getItem( "role" )?.toUpperCase().includes("QA1") && values.comments,
                qa_level1_stage: localStorage.getItem( "role" )?.toUpperCase().includes("QA1") && 1,

                qa_level2_action: localStorage.getItem( "role" )?.toUpperCase().includes("QA2") && values.action,
                qa_level2_comments: localStorage.getItem( "role" )?.toUpperCase().includes("QA2") && values.comments,
                qa_level2_stage: localStorage.getItem( "role" )?.toUpperCase().includes("QA2") && 2,

                qa_level3_action: localStorage.getItem( "role" )?.toUpperCase().includes("QA3") && values.action,
                qa_level3_comments: localStorage.getItem( "role" )?.toUpperCase().includes("QA3") && values.comments,
                qa_level3_stage: localStorage.getItem( "role" )?.toUpperCase().includes("QA3") && 3,

                progress: localStorage.getItem( "role" )?.toUpperCase().includes("QA3") && parseInt( result.progress ) + 20,
                stage: localStorage.getItem( "role" )?.toUpperCase().includes("QA3") && parseInt( result.stage ) + 1,
                actioned_by: localStorage.getItem( "username" ),
                role: localStorage.getItem( "role" ),
                qa_level: localStorage.getItem( "application_action" ),
                level_of_certification_compliance: values.level_of_certification_compliance,
                level_of_certification_remarks: values.level_of_certification_remarks,
                required_documents_compliance: values.required_documents_compliance,
                required_documents_remarks: values.required_documents_remarks,
                audit_report_complete_compliance: values.audit_report_complete_compliance,
                audit_report_complete_remarks: values.audit_report_complete_remarks,
                payment_of_fees_compliance: values.payment_of_fees_compliance,
                payment_of_fees_remarks: values.payment_of_fees_remarks,
                domain_applied_for_compliance: values.domain_applied_for_compliance,
                domain_applied_for_remarks: values.domain_applied_for_remarks,
                certification_level_compliance: values.certification_level_compliance,
                certification_level_remarks: values.certification_level_remarks,
                required_document: values.required_document,
                // task: "Schedule_Audit",
                // comment: "Audit has been scheduled",
                // created_by: localStorage.getItem( "email" ),
                // email_address: state.email
            } )
            if( response.data ) {
                await setCircularLoading( false )
                //   dispatch( setAssuranceModal( { assuranceFlag: false, title: "" } ) )
                alert( response.data.message )
                await localStorage.setItem( "link", "dashboard" )
                return window.location.reload()
            }
        } catch (error) {
            console.log("exception thrown")
            console.log(error)
        }
    }

    const handleApproval = async ( values ) => {
        await setCircularLoading( true )
        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
                id: result.id,
                progress: values.action === "APPROVED" ? 100 : 90,
                stage: 9,
                status: localStorage.getItem( "role" )?.toUpperCase().includes("APPROVER") && values.action,
                action: localStorage.getItem( "role" )?.toUpperCase().includes("APPROVER") && values.action,
                actioned_by: values.actioned_by,
                role: localStorage.getItem( "role" ),
                comments: values.comments,
                created_by: localStorage.getItem( "username" ),
                email_address: result.created_by,
                ugpass_state: localStorage.getItem( "state" )
            } )
            if( response.data ) {
                await setCircularLoading( false )
                //   dispatch( setApproveModal( { approvalFlag: false, title: "" } ) )
                console.log(response.data.message)
                alert( response.data.message )
                return window.location.reload()
            }
        } catch (error) {}
    }

    const handleAuditorAssignment = async ( values ) => {
        await setCircularLoading( true )
        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/assign_auditor`, {
                id: result.id,
                assigned_auditor: values.assigned_auditor,
                comments: values.comments,
                actioned_by: localStorage.getItem( "username" ),
                role: localStorage.getItem( "role" ),
                email_address: result.created_by
            } )
            if( response.data ) {
                await setCircularLoading( false )
                //   dispatch( setApproveModal( { approvalFlag: false, title: "" } ) )
                alert( response.data.message )
                return window.location.reload()
            }
        } catch (error) {}
    }

    if( loadingRemarks ) {
        return <div>{`Loading...`}</div>
    }

    if( localStorage.getItem( "role" )?.toUpperCase() === "APPLICANT" && parseInt( result?.stage ) === 5 ) {
        <Panel label="Auditor's Audit Report">
        </Panel>
    }


    if( localStorage.getItem( "role" )?.toUpperCase().includes("VERIFIER") && localStorage.getItem( "application_action" )?.toUpperCase() === "VERIFIER" ) {
        return (
            <Panel label="Document Verification">
                <div className="flex flex-col items-start justify-center px-5 py-2">
                    {/* <h2>{`Document Verification`}</h2> */}
                    <Formik initialValues={{
                        action: comments[ 0 ]?.action || "",
                        actioned_by: localStorage.getItem( "username" ),
                        comments: comments[ 0 ]?.comments || ""
                        }} onSubmit={handleDocumentsVerify}>
                        { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                            return (
                                <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                                    <div className="w-full grid grid-rows-2 gap-1">
                                        <SelectFieldIcon 
                                            name="action"
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            value={values.action}
                                            label="Action"
                                            required={true}
                                            disabled={comments[ 0 ]?.action ? true : false}
                                            options={[ 
                                                { id: 1, value: "Pass", label: "Pass" },
                                                { id: 2, value: "Fail", label: "Fail" }
                                            ]}
                                            question="Next Course of Action" />
                                        <TextAreaIcon
                                            rows={3}
                                            cols={5}
                                            name="comments"
                                            value={values.comments}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            label="Comments"
                                            disabled={comments[ 0 ]?.action ? true : false}
                                            question={`Add any comments/remarks`}
                                            required={true}
                                        />
                                    </div>
                                    {circularLoading ? (
                                        <div className="flex items-center justify-center">
                                            <CircularProgress size={24} color="primary" />
                                        </div>
                                    ):
                                    ( 
                                        ! ( comments[ 0 ]?.action ) && 
                                        ( <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                            {`Submit`}
                                        </button> )
                                    )}
                                </form>
                            )
                        }  }
                    </Formik>
                </div>
            </Panel>
        )
    }

    if( localStorage.getItem( "role" )?.toUpperCase().includes("AUDITOR") && localStorage.getItem( "application_action" )?.toUpperCase() === "AUDITOR" && (!result?.scheduled_action || result?.scheduled_action === "PENDING") ) {
        return (
            <Panel label={`Schedule Audit Date`}>
            <div className="flex flex-col items-start justify-center px-5 py-2">
                <Formik initialValues={{
                    action: comments[ 0 ]?.action || "",
                    actioned_by: localStorage.getItem( "username" ),
                    comments: comments[ 0 ]?.comments || "",
                    scheduled_date: `${result?.scheduled_date}`,
                    scheduled_location: `${result.district} ${result.county} ${result.subcounty} ${result.village}`,
                    audit_leader: `${result?.audit_leader == null ? "" : result?.audit_leader}`,
                    audit_email: `${result?.audit_email == null ? "" : result?.audit_email}`,
                    audit_phone: `${result?.audit_phone == null ? "" : result?.audit_phone}`
                    }} onSubmit={handleSchedule}>
                    { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                        return (
                            <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                                <div className="w-full grid grid-cols-2 gap-2">
                                    {/* <SelectFieldIcon 
                                        name="action"
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        value={values.action}
                                        label="Action"
                                        required={true}
                                        disabled={comments[ 0 ]?.action ? true : false}
                                        options={[ 
                                            { id: 1, value: "Sche", label: "Pass" },
                                            { id: 2, value: "Fail", label: "Fail" }
                                        ]}
                                        question="Next Course of Action" /> */}
                                    <TextFieldIcon 
                                        type="date"
                                        name="scheduled_date"
                                        value={values.scheduled_date}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        label="Proposed Date"
                                        disabled={false}
                                        question={`Scheduled Date of Audit`}
                                        required={true} />
                                    
                                    <TextFieldIcon 
                                        type="text"
                                        name="scheduled_location"
                                        value={values.scheduled_location}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        label="Location"
                                        disabled={result?.district ? true : false}
                                        question={`Location`}
                                        required={true} />
                                    
                                    <TextFieldIcon 
                                        type="text"
                                        name="audit_leader"
                                        value={values.audit_leader}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        label="Audit Team Leader"
                                        disabled={result?.scheduled_date ? true : false}
                                        question={`Name of Audit Team Leader`}
                                        required={false} />
                                    
                                    <TextFieldIcon 
                                        type="text"
                                        name="audit_phone"
                                        value={values.audit_phone}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        label="Auditee Phone Contact"
                                        disabled={result?.scheduled_date ? true : false}
                                        question={`Auditee Phone Contact`}
                                        required={false} />
                                    
                                    <TextFieldIcon 
                                        type="email"
                                        name="audit_email"
                                        value={values.audit_email }
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        label="Audit Email Address"
                                        disabled={result?.scheduled_date ? true : false}
                                        question={`Email Address`}
                                        required={false} />

                                    <TextAreaIcon
                                        rows={3}
                                        cols={5}
                                        name="comments"
                                        value={values.comments}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        label="Comments"
                                        disabled={comments[ 0 ]?.action ? true : false}
                                        question={`Add any comments/remarks`}
                                        required={true}
                                    />
                                </div>

                                {circularLoading ? (
                                    <div className="flex items-center justify-center">
                                        <CircularProgress size={24} color="primary" />
                                    </div>
                                ):
                                ( 
                                    (! ( comments[ 0 ]?.action ) || (result?.scheduled_action === "PENDING")) && 
                                    ( <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                        {`Submit`}
                                    </button> )
                                )}
                            </form>
                        )
                    }  }
                </Formik>
            </div>
            </Panel>
        
        )
    }

    if( localStorage.getItem( "role" )?.toUpperCase().includes("FINANCE") && result?.verification_status ) {
        return (
            <Panel label={`Set Certification Fees`}>
                <div className="flex flex-col items-start justify-center px-5 py-2">
                    <Formik initialValues={{
                        action: comments[ 0 ]?.action || "",
                        actioned_by: localStorage.getItem( "username" ),
                        comments: comments[ 0 ]?.comments || "",
                        certification_fee: [],
                        scheduled_location: `${result.district} ${result.county} ${result.subcounty} ${result.village}`,
                        finance_annual_turnover: `${result.annual_turnover}`
                        }} onSubmit={handleFinance}>
                        { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                            return (
                                <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                                    <div className="w-full grid grid-cols-2 gap-2">                                        
                                        <SelectFieldIcon 
                                            name="finance_annual_turnover"
                                            handleChange={evt => {
                                                handleChange(evt)
                                                handleAnnualTurnOverChange(evt)
                                            }}
                                            handleBlur={handleBlur}
                                            value={values.finance_annual_turnover}
                                            iconComponent={<FaBuilding color={`#AFC836`} />} 
                                            label="Annual Turnover / Income"
                                            required={true}
                                            disabled={false}
                                            options={data.turnover.map( ( { id, label, value } ) => {
                                                return { id, label, value }
                                            } )}
                                            question="Annual Turnover / Income" />
                                        
                                        <TextFieldIcon 
                                            type="text"
                                            name="scheduled_location"
                                            value={values.scheduled_location}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            label="Location"
                                            disabled={result?.district ? true : false}
                                            question={`Location`}
                                            required={true} />

                                        <div className="text-gray-700 text-xs mb-3">
                                            <p className="py-1">
                                                Choose fees to pay<span className="text-red-500">*</span>
                                            </p>

                                            { (result?.category === "Company") ? (
                                                <>
                                                    {(incomeBand === "Less_250M") && 
                                                        data.less_than_250M_bands.map( ({ id, label, value } ) => {
                                                            return <>
                                                                        <input type="checkbox" onClick={() => {setCertificationFee( [...certificationFee, parseInt(value)])}} name="certification_fee[]" value={value} /> {label}<br/>
                                                                    </> 
                                                        })
                                                    } 

                                                    {(incomeBand === "Less_500M") &&
                                                        data.less_than_500M_bands.map( ({ id, label, value } ) => {
                                                            return <>
                                                                        <input type="checkbox" onClick={() => {setCertificationFee( [...certificationFee, parseInt(value)])}} name="certification_fee[]" value={value} /> {label}<br/>
                                                                    </> 
                                                        })
                                                    } 

                                                    {(incomeBand === "Less_3BN") && 
                                                        data.less_than_3B_bands.map( ({ id, label, value } ) => {
                                                            return <>
                                                                        <input type="checkbox" onClick={() => {setCertificationFee( [...certificationFee, parseInt(value)])}} name="certification_fee[]" value={value} /> {label}<br/>
                                                                    </> 
                                                        })
                                                    }

                                                    {(incomeBand === "More_3BN") && 
                                                        data.more_than_3B_bands.map( ({ id, label, value } ) => {
                                                            return <>
                                                                        <input type="checkbox" onClick={() => {setCertificationFee( [...certificationFee, parseInt(value)])}} name="certification_fee[]" value={value} /> {label}<br/>
                                                                    </> 
                                                        })
                                                    } 
                                                </>
                                            ) : (
                                                <div className="py-2">
                                                    <input type="checkbox" onClick={() => {setCertificationFee( [...certificationFee, 473000])}} name="certification_fee[]" value={473000} /> 473,000 Application for certification for individuals<br/>
                                                </div>
                                            ) }
                                        </div>                                       

                                        <TextAreaIcon
                                            rows={3}
                                            cols={5}
                                            name="comments"
                                            value={values.comments}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            label="Comments"
                                            disabled={comments[ 0 ]?.action ? true : false}
                                            question={`Add any comments/remarks`}
                                            required={true}
                                        />

                                        <div className="font-extrabold text-1xl pl-20">
                                            {certificationFee.length > 0 && (`Amount to pay = `+numberWithCommas(certificationFee.reduce((acc, number) => acc + number, 0)) + ` /=`)}
                                        </div>
                                    </div>

                                    {circularLoading ? (
                                        <div className="flex items-center justify-center">
                                            <CircularProgress size={24} color="primary" />
                                        </div>
                                    ):
                                    ( 
                                        ! ( comments[ 0 ]?.action ) && 
                                        ( <button 
                                            type="submit" 
                                            className={`text-xs px-2 py-1 ${
                                                values.comments && values.comments.trim() !== '' 
                                                    ? 'bg-purple-700 text-white' 
                                                    : 'bg-gray-400 text-gray-600 cursor-not-allowed'
                                            }`}
                                            disabled={!values.comments || values.comments.trim() === ''}
                                        >
                                            {`Submit`}
                                        </button> )
                                    )}
                                </form>
                            )
                        }  }
                    </Formik>
                </div>
            </Panel>
        
        )
    }

    if( localStorage.getItem( "role" )?.toUpperCase().includes("AUDITOR") && ((localStorage.getItem( "application_action" )?.toUpperCase() === "AUDITOR" && result?.scheduled_action === "DATE_CONFIRMED") || (result?.qa_level1_action?.toUpperCase() === "REJECTION" && result?.stage === 4)) ) {
        return (
            <Panel label={`Add Audit Report`}>

                <div className="flex flex-col items-start justify-center px-5 py-2">
                    <Formik initialValues={{
                        action: "",
                        actioned_by: localStorage.getItem( "username" ),
                        comments: "",
                        attachment: "",
                        type_of_audit: auditReport?.type_of_audit,
                        applicable_regulation: auditReport?.applicable_regulation,
                        applicable_standard: auditReport?.applicable_standard,
                        audit_site: auditReport?.audit_site,
                        audit_date: auditReport?.audit_date,
                        service_name: auditReport?.service_name,
                        audit_criteria: auditReport?.audit_criteria,
                        proof_of_office_location: auditReport?.proof_of_office_location,
                        proof_of_office_location_comment: auditReport?.proof_of_office_location_comment,
                        proof_of_it_personnel: auditReport?.proof_of_it_personnel,
                        proof_of_it_personnel_comment: auditReport?.proof_of_it_personnel_comment,
                        proof_of_manuals: auditReport?.proof_of_manuals,
                        proof_of_manuals_comment: auditReport?.proof_of_manuals_comment,
                        proof_of_past_services: auditReport?.proof_of_past_services,
                        proof_of_past_services_comment: auditReport?.proof_of_past_services_comment,
                        audit_notes: auditReport?.audit_notes,
                        }} onSubmit={handleAuditReport}>
                        { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                            return (
                                <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>
                                    <Panel label="Audit Profile">
                                        <SelectFieldIcon 
                                            name="type_of_audit"
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            value={values.type_of_audit}
                                            label="Type of Audit"
                                            required={true}
                                            question={`Type of Audit`}
                                            disabled={false}
                                            options={[ 
                                                { id: 1, value: "Inspection", label: "Inspection" }, { id: 2, value: "New", label: "New"}
                                            ]}
                                        />

                                        {/* <TextFieldIcon 
                                            type="text"
                                            name="applicable_regulation"
                                            value={values.applicable_regulation || "NITA-U (Certification of Providers of IT Products and Services) (Amendment) Regulation 2018"}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            label="Applicable Regulation"
                                            disabled={false}
                                            question={`Applicable Regulation`}
                                            required={true} 
                                        /> */}
                                        <SelectFieldIcon 
                                            name="applicable_regulation"
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            value={values.applicable_regulation}
                                            label="Applicable Regulation"
                                            required={true}
                                            question={`Applicable Regulation`}
                                            disabled={false}
                                            options={[ 
                                                { id: 1, value: "NITA-U (Certification of Providers of IT Products and Services) (Amendment) Regulation 2018", label: "NITA-U (Certification of Providers of IT Products and Services) (Amendment) Regulation 2018" }, 
                                                { id: 2, value: "NITA-U (Authentication of Information Technology Training) Regulation 2016", label: "NITA-U (Authentication of Information Technology Training) Regulation 2016"},
                                                { id: 3, value: "The Electronic Transactions Act, 2011", label: "The Electronic Transactions Act, 2011"},
                                                { id: 4, value: "The Data Protection and Privacy Act, 2019", label: "The Data Protection and Privacy Act, 2019"}
                                            ]}
                                        />

                                        {/* <TextFieldIcon 
                                            type="text"
                                            name="applicable_standard"
                                            value={values.applicable_standard}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            label="Applicable Standard(s)"
                                            disabled={false}
                                            question={`Applicable Standard(s)`}
                                            required={true} 
                                        /> */}
                                        <SelectFieldIcon 
                                            name="applicable_standard"
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            value={values.applicable_standard}
                                            label="Applicable Standard(s)"
                                            required={true}
                                            question={`Applicable Standard(s)`}
                                            disabled={false}
                                            options={[ 
                                                { id: 1, value: "US/ISO/IEC/20000", label: "US/ISO/IEC/20000" }, { id: 2, value: "US/ISO/IEC/9000", label: "US/ISO/IEC/9000"}
                                            ]}
                                        />

                                        <TextFieldIcon 
                                            type="text"
                                            name="audit_site"
                                            value={values.audit_site}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            label="Audit Site"
                                            disabled={false}
                                            question={`Audit Site`}
                                            required={true} 
                                        />

                                        <TextFieldIcon 
                                        type="date"
                                        name="audit_date"
                                        value={values.audit_date}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        label="Suggest Date"
                                        disabled={false}
                                        question={`Audit Date`}
                                        required={true} />

                                        {result?.category === "Individual"  && 
                                            (<>
                                                <div className="flex flex-row items-center justify-center w-24">
                                                <button onClick={() => handleAddSkills()} type="button" 
                                                    className="bg-slate-500 text-xs rounded-sm text-white px-2 py-1">
                                                    {`Add Skill`}
                                                </button>
                                                </div>

                                                {skillNames.map( (item, idx ) => {
                                                return (
                                                <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
                                                <SelectFieldIcon 
                                                    name="service_name"
                                                    handleChange={evt => {
                                                    handleChange( evt, idx )
                                                    handleSkillsInputs( evt, idx )
                                                    }}
                                                    handleBlur={handleBlur}
                                                    value={skillNames[idx].service_name}
                                                    iconComponent={<FaBuilding color={`#AFC836`} />} 
                                                    label="Skill Code"
                                                    required={true}
                                                    options={skillsDropdown.map( ( { id, label, value } ) => {
                                                    return { id, label, value }
                                                    } )}
                                                    question="Skill Code" 
                                                />
                                    
                                                <div className="flex items-center justify-center w-14">
                                                    {idx > 0 && ( <button onClick={() => handleSkillsRemove( idx )} type="button" 
                                                    className="bg-red-500 text-xs rounded-sm text-white px-2 py-1">
                                                    {`Remove`}
                                                    </button> ) }
                                                </div>
                                                </div>)
                                            })}
                                            </>)
                                        }

                                        {result?.category === "Company"  && (
                                            <>
                                                <div className="flex flex-row items-center justify-center w-24">
                                                <button onClick={() => handleAddService()} type="button" 
                                                    className="bg-slate-500 text-xs rounded-sm text-white px-2 py-1">
                                                    {`Add Service`}
                                                </button>
                                                </div>

                                                {serviceNames.map( (item, idx ) => {
                                                return (
                                                    <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
                                                    <SelectFieldIcon 
                                                    name="service_name"
                                                    handleChange={evt => {
                                                        handleChange( evt, idx )
                                                        handleInputs( evt, idx )
                                                    }}
                                                    handleBlur={handleBlur}
                                                    value={serviceNames[idx].service_name}
                                                    iconComponent={<FaBuilding color={`#AFC836`} />} 
                                                    label="Service ISIC Code"
                                                    required={true}
                                                    options={servicesDropdown.map( ( { id, label, value } ) => {
                                                        return { id, label, value }
                                                    } )}
                                                    question="Service ISIC Code" 
                                                    />

                                                    <div className="flex items-center justify-center w-14">
                                                    {idx > 0 && ( <button onClick={() => handleRemove( idx )} type="button" 
                                                        className="bg-red-500 text-xs rounded-sm text-white px-2 py-1">
                                                        {`Remove`}
                                                    </button> ) }
                                                    </div>
                                                </div>)
                                                })}
                                            </>
                                        )}
                                    </Panel>

                                    <Panel label="Audit Findings">
                                        {/* <TextAreaIcon
                                            rows={6}
                                            cols={5}
                                            name="distribution_limitations_responsibilties"
                                            value={values.distribution_limitations_responsibilties}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            label="Distribution/Confidentiality/Rights of ownership/Limitations/Responsibilities"
                                            disabled={false}
                                            question={`Distribution/Confidentiality/Rights of ownership/Limitations/Responsibilities`}
                                            required={true}
                                        /> */}

                                        {/* <TextFieldIcon 
                                            type="text"
                                            name="audit_criteria"
                                            value={values.audit_criteria}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            label="Audit Criteria"
                                            disabled={false}
                                            question={`Audit Criteria`}
                                            required={true} 
                                        /> */}
                                        <SelectFieldIcon 
                                            name="audit_criteria"
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            value={values.audit_criteria}
                                            label="Audit Criteria"
                                            required={true}
                                            question={`Audit Criteria`}
                                            disabled={false}
                                            options={[ 
                                                { id: 1, value: "Physical checking of legal documents, interaction with IT Professionals", label: "Physical checking of legal documents, interaction with IT Professionals" }, { id: 2, value: "Online checking of legal documents, interaction with IT Professionals", label: "Online checking of legal documents, interaction with IT Professionals"}
                                            ]}
                                        />

                                        <table className="w-full bg-gray-50 rounded overflow-x-scroll text-gray-700 py-1 text-xs border-collapse mt-5 table-fixed">
                                            <thead className="bg-gray-300">
                                                <tr>
                                                    <td className="border border-slate-300">Requirements</td>
                                                    <td className="border border-slate-300">Findings</td>
                                                    <td className="border border-slate-300">Comments</td>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                {/* <tr>
                                                    <td className="border border-slate-300">Proof to legal status</td>
                                                    <td className="border border-slate-300">
                                                        <TextAreaIcon
                                                            rows={6}
                                                            cols={5}
                                                            name="proof_of_legal_status"
                                                            value={values.proof_of_legal_status}
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            label="Findings and recommendations"
                                                            disabled={false}
                                                            required={true}
                                                        />
                                                    </td>
                                                    <td className="border border-slate-300">
                                                        <SelectFieldIcon 
                                                        name="proof_of_legal_status_comment"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.proof_of_legal_status_comment}
                                                        label="Action"
                                                        required={true}
                                                        disabled={false}
                                                        options={[ 
                                                            { id: 1, value: "Pass", label: "Pass" }, { id: 2, value: "Fail", label: "Fail"}
                                                        ]}
                                                        />
                                                    </td>
                                                </tr> 

                                                <tr>
                                                    <td className="border border-slate-300">Proof of registration for <br/>tax purposes</td>
                                                    <td className="border border-slate-300">
                                                        <TextAreaIcon
                                                            rows={6}
                                                            cols={5}
                                                            name="proof_of_registration"
                                                            value={values.proof_of_registration}
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            label="Findings and recommendations"
                                                            disabled={false}
                                                            required={true}
                                                        />
                                                    </td>
                                                    <td className="border border-slate-300">
                                                        <SelectFieldIcon 
                                                        name="proof_of_registration_comment"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.proof_of_registration_comment}
                                                        label="Action"
                                                        required={true}
                                                        disabled={false}
                                                        options={[ 
                                                            { id: 1, value: "Pass", label: "Pass" }, { id: 2, value: "Fail", label: "Fail"}
                                                        ]}
                                                        />
                                                    </td>
                                                </tr> */}

                                                <tr>
                                                    <td className="border border-slate-300">Proof of Office location and <br/>necessary facilities, equipment <br/>and infrastructure</td>
                                                    <td className="border border-slate-300">
                                                        <TextAreaIcon
                                                            rows={6}
                                                            cols={5}
                                                            name="proof_of_office_location"
                                                            value={values.proof_of_office_location}
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            label="Findings and recommendations"
                                                            disabled={false}
                                                            required={true}
                                                        />
                                                    </td>
                                                    <td className="border border-slate-300">
                                                        <SelectFieldIcon 
                                                        name="proof_of_office_location_comment"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.proof_of_office_location_comment}
                                                        label="Action"
                                                        required={true}
                                                        disabled={false}
                                                        options={[ 
                                                            { id: 1, value: "Pass", label: "Pass" }, { id: 2, value: "Fail", label: "Fail"}
                                                        ]}
                                                        />
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="border border-slate-300">Proof of IT Personnel used to <br/>provide IT Services</td>
                                                    <td className="border border-slate-300">
                                                        <TextAreaIcon
                                                            rows={6}
                                                            cols={5}
                                                            name="proof_of_it_personnel"
                                                            value={values.proof_of_it_personnel}
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            label="Findings and recommendations"
                                                            disabled={false}
                                                            required={true}
                                                        />
                                                    </td>
                                                    <td className="border border-slate-300">
                                                        <SelectFieldIcon 
                                                        name="proof_of_it_personnel_comment"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.proof_of_it_personnel_comment}
                                                        label="Action"
                                                        required={true}
                                                        disabled={false}
                                                        options={[ 
                                                            { id: 1, value: "Pass", label: "Pass" }, { id: 2, value: "Fail", label: "Fail"}
                                                        ]}
                                                        />
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="border border-slate-300">Proof of applicable quality<br/> and technical manuals</td>
                                                    <td className="border border-slate-300">
                                                        <TextAreaIcon
                                                            rows={6}
                                                            cols={5}
                                                            name="proof_of_manuals"
                                                            value={values.proof_of_manuals}
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            label="Findings and recommendations"
                                                            disabled={false}
                                                            required={true}
                                                        />
                                                    </td>
                                                    <td className="border border-slate-300">
                                                        <SelectFieldIcon 
                                                        name="proof_of_manuals_comment"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.proof_of_manuals_comment}
                                                        label="Action"
                                                        required={true}
                                                        disabled={false}
                                                        options={[ 
                                                            { id: 1, value: "Pass", label: "Pass" }, { id: 2, value: "Fail", label: "Fail"}
                                                        ]}
                                                        />
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="border border-slate-300">Proof of satisfactory past services<br/> provided in the field of IT service/product<br/> for which certification is sought.</td>
                                                    <td className="border border-slate-300">
                                                        <TextAreaIcon
                                                            rows={6}
                                                            cols={5}
                                                            name="proof_of_past_services"
                                                            value={values.proof_of_past_services}
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            label="Findings and recommendations"
                                                            disabled={false}
                                                            required={true}
                                                        />
                                                    </td>
                                                    <td className="border border-slate-300">
                                                        <SelectFieldIcon 
                                                        name="proof_of_past_services_comment"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.proof_of_past_services_comment}
                                                        label="Action"
                                                        required={true}
                                                        disabled={false}
                                                        options={[ 
                                                            { id: 1, value: "Pass", label: "Pass" }, { id: 2, value: "Fail", label: "Fail"}
                                                        ]}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <TextAreaIcon
                                            rows={3}
                                            cols={5}
                                            name="audit_notes"
                                            value={values.audit_notes}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            label="Audit Notes"
                                            disabled={false}
                                            question={`Audit Notes`}
                                            required={true}
                                        />
                                    </Panel>

                                    <Panel label="Course of Action">
                                        <div className="w-full grid grid-cols-2 gap-2">
                                            <SelectFieldIcon 
                                                name="action"
                                                handleChange={handleChange}
                                                handleBlur={handleBlur}
                                                value={values.action}
                                                label="Action"
                                                required={true}
                                                disabled={false}
                                                options={[ 
                                                    { id: 1, value: "Approve", label: "Recommend for Approval" }, { id: 2, value: "Reject", label: "Recommend for Rejection"}
                                                ]}
                                                question="Next Course of Action" />
                                            
                                            {/* <FileFieldIcon
                                                noPadding
                                                name="attachment"
                                                value={values?.attachment}
                                                handleChange={evt => {
                                                    handleChange(evt)
                                                    handleFile( evt, "audit_report" )
                                                }}
                                                label="Audit Report (Less than 5 MB)"
                                                question="Add Audit Report (Less than 5 MB)" 
                                                required={false} 
                                            /> */}

                                            <TextAreaIcon
                                                rows={3}
                                                cols={5}
                                                name="comments"
                                                value={values.comments}
                                                handleChange={handleChange}
                                                handleBlur={handleBlur}
                                                label="Comments"
                                                disabled={false}
                                                question={`Add any comments/remarks`}
                                                required={true}
                                            />
                                        </div>

                                        <div className="flex flex-row items-center justify-center w-24">
                                            <button onClick={() => handleAddAuditeeMember()} type="button" 
                                                className="bg-slate-500 text-xs rounded-sm text-white px-2 py-1">
                                                {`Add Member`}
                                            </button>
                                            </div>

                                            {auditeeMemberNames.map( (item, idx ) => {
                                                return (
                                                <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
                                                {/* <SelectFieldIcon 
                                                    name="auditee_members"
                                                    handleChange={evt => {
                                                    handleChange( evt, idx )
                                                    handleAuditeeMemberInputs( evt, idx )
                                                    }}
                                                    handleBlur={handleBlur}
                                                    value={auditeeMemberNames[idx].auditee_members}
                                                    iconComponent={<FaBuilding color={`#AFC836`} />} 
                                                    label="Auditee Members"
                                                    required={true}
                                                    options={skillsDropdown.map( ( { id, label, value } ) => {
                                                    return { id, label, value }
                                                    } )}
                                                    question="Auditee Members" 
                                                /> */}

                                                <TextFieldIcon
                                                    rows={3}
                                                    cols={5}
                                                    name="auditee_members"
                                                    value={auditeeMemberNames[idx].auditee_members}
                                                    handleChange={handleChange}
                                                    handleBlur={evt => {
                                                            handleBlur( evt, idx )
                                                            handleAuditeeMemberInputs( evt, idx )
                                                        }
                                                    }
                                                    label="Auditee Members"
                                                    disabled={false}
                                                    question={`Audit Members`}
                                                    required={true}
                                                />
                                    
                                                <div className="flex items-center justify-center w-14">
                                                    {idx > 0 && ( <button onClick={() => handleAuditeeMemberRemove( idx )} type="button" 
                                                    className="bg-red-500 text-xs rounded-sm text-white px-2 py-1">
                                                    {`Remove`}
                                                    </button> ) }
                                                </div>
                                                </div>)
                                            })}

                                        {circularLoading ? (
                                            <div className="flex items-center justify-center">
                                                <CircularProgress size={24} color="primary" />
                                            </div>
                                        ):
                                        ( 
                                            <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                            {`Submit`}
                                            </button>
                                        )}
                                    </Panel>
                                </form>
                            )
                        }  }
                    </Formik>
                </div>
            </Panel>
        
        )
    }

    if( localStorage.getItem( "role" )?.toUpperCase().includes("QA1") && localStorage.getItem( "application_action" )?.toUpperCase() === "ASSIGN_AUDITOR" ) {
        return (
            <Panel label="Assign Auditor">
                <div className="flex flex-col items-start justify-center px-5 py-2">
                <Formik initialValues={{
                    action: comments[ 0 ]?.action || "",
                    actioned_by: localStorage.getItem( "username" ),
                    comments: comments[ 0 ]?.comments || ""
                    }} onSubmit={handleAuditorAssignment}>
                    { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                        return (
                            <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                                <div className="w-full grid grid-rows-2 gap-1">

                                    <SelectFieldIcon 
                                        name="assigned_auditor"
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        value={result.assigned_auditor}
                                        label="Action"
                                        required={true}
                                        disabled={comments[ 0 ]?.assigned_auditor ? true : false}
                                        options={auditors.map( ( { id, label, value } ) => {
                                            return { id, label, value }
                                        } )}
                                        question="Select Auditor" />
                                        
                                    <TextAreaIcon
                                        rows={3}
                                        cols={5}
                                        name="comments"
                                        value={values.comments}
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        label="Comments"
                                        disabled={comments[ 0 ]?.action ? true : false}
                                        question={`Add any comments/remarks`}
                                        required={true}
                                    />
                                </div>

                                {circularLoading ? (
                                    <div className="flex items-center justify-center">
                                        <CircularProgress size={24} color="primary" />
                                    </div>
                                ):
                                ( 
                                    ! ( comments[ 0 ]?.action ) && 
                                    ( <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                        {`Assign Auditor`}
                                    </button> )
                                )}
                            </form>
                        )
                    }  }
                </Formik>
            </div>
            </Panel>
        )
    }

    if( localStorage.getItem( "role" )?.toUpperCase().includes("SECURITY") && localStorage.getItem( "application_action" )?.toUpperCase() === "SECURITY" ) {
        return (
            <Panel label="Security Clearance Form">
                <div className="flex flex-col items-start px-5 py-2">
                <Formik initialValues={{
                    action: comments[ 0 ]?.action || "",
                    actioned_by: localStorage.getItem( "username" ),
                    comments: comments[ 0 ]?.comments || ""
                    }} onSubmit={handleSecurityClearanceForm}>
                    { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                        return (
                            <form className="w-full bg-white" onSubmit={handleSubmit}>

                                <div className="w-full">
                                    <table className="w-full bg-gray-50 rounded overflow-x-scroll text-gray-700 py-1 text-xs border-collapse mt-5 table-fixed">
                                        <thead className="bg-gray-300">
                                            <tr>
                                                <td className="border border-slate-300">Requirements</td>
                                                <td className="border border-slate-300">Findings</td>
                                                <td className="border border-slate-300">Comments</td>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            <tr>
                                                <td className="border border-slate-300">
                                                    Code of conduct (for your staff) detailing written collection of the rules, principles, values and employee expectations, behavior, and relationships that the organization considers significant and believes are fundamental to its successful operations
                                                </td>
                                                <td className="border border-slate-300">
                                                    <TextAreaIcon
                                                        rows={6}
                                                        cols={5}
                                                        name="code_of_conduct"
                                                        value={values.code_of_conduct}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        label="Findings"
                                                        disabled={false}
                                                        required={true}
                                                    />
                                                </td>
                                                <td className="border border-slate-300">
                                                    <SelectFieldIcon 
                                                    name="code_of_conduct_comment"
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    value={values.code_of_conduct_comment}
                                                    label="Action"
                                                    required={true}
                                                    disabled={false}
                                                    options={[ 
                                                        { id: 1, value: "Pass", label: "Pass" }, { id: 2, value: "Fail", label: "Fail"}
                                                    ]}
                                                    />
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="border border-slate-300">
                                                    Terms or conditions of agreement, including any guarantees, that apply to your systems
                                                </td>
                                                <td className="border border-slate-300">
                                                    <TextAreaIcon
                                                        rows={6}
                                                        cols={5}
                                                        name="terms_of_conditions_of_agreement"
                                                        value={values.terms_of_conditions_of_agreement}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        label="Findings"
                                                        disabled={false}
                                                        required={true}
                                                    />
                                                </td>
                                                <td className="border border-slate-300">
                                                    <SelectFieldIcon 
                                                    name="terms_of_conditions_of_agreement_comment"
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    value={values.terms_of_conditions_of_agreement_comment}
                                                    label="Action"
                                                    required={true}
                                                    disabled={false}
                                                    options={[ 
                                                        { id: 1, value: "Pass", label: "Pass" }, { id: 2, value: "Fail", label: "Fail"}
                                                    ]}
                                                    />
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="border border-slate-300">
                                                    Staff confidentiality & non-disclosure agreements
                                                </td>
                                                <td className="border border-slate-300">
                                                    <TextAreaIcon
                                                        rows={6}
                                                        cols={5}
                                                        name="staff_confidentiality_and_non_disclosure"
                                                        value={values.staff_confidentiality_and_non_disclosure}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        label="Findings"
                                                        disabled={false}
                                                        required={true}
                                                    />
                                                </td>
                                                <td className="border border-slate-300">
                                                    <SelectFieldIcon 
                                                    name="staff_confidentiality_and_non_disclosure_comment"
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    value={values.staff_confidentiality_and_non_disclosure_comment}
                                                    label="Action"
                                                    required={true}
                                                    disabled={false}
                                                    options={[ 
                                                        { id: 1, value: "Pass", label: "Pass" }, { id: 2, value: "Fail", label: "Fail"}
                                                    ]}
                                                    />
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="border border-slate-300">
                                                    Data retention mechanism/policy
                                                </td>
                                                <td className="border border-slate-300">
                                                    <TextAreaIcon
                                                        rows={6}
                                                        cols={5}
                                                        name="data_retention_mechanism"
                                                        value={values.data_retention_mechanism}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        label="Findings"
                                                        disabled={false}
                                                        required={true}
                                                    />
                                                </td>
                                                <td className="border border-slate-300">
                                                    <SelectFieldIcon 
                                                    name="data_retention_mechanism_comment"
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    value={values.data_retention_mechanism_comment}
                                                    label="Action"
                                                    required={true}
                                                    disabled={false}
                                                    options={[ 
                                                        { id: 1, value: "Pass", label: "Pass" }, { id: 2, value: "Fail", label: "Fail"}
                                                    ]}
                                                    />
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="border border-slate-300">
                                                    Internal information security awareness for staff
                                                </td>
                                                <td className="border border-slate-300">
                                                    <TextAreaIcon
                                                        rows={6}
                                                        cols={5}
                                                        name="internal_information_security_awareness"
                                                        value={values.internal_information_security_awareness}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        label="Findings"
                                                        disabled={false}
                                                        required={true}
                                                    />
                                                </td>
                                                <td className="border border-slate-300">
                                                    <SelectFieldIcon 
                                                    name="internal_information_security_awareness_comment"
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    value={values.internal_information_security_awareness_comment}
                                                    label="Action"
                                                    required={true}
                                                    disabled={false}
                                                    options={[ 
                                                        { id: 1, value: "Pass", label: "Pass" }, { id: 2, value: "Fail", label: "Fail"}
                                                    ]}
                                                    />
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="border border-slate-300">
                                                    Information Security policy
                                                </td>
                                                <td className="border border-slate-300">
                                                    <TextAreaIcon
                                                        rows={6}
                                                        cols={5}
                                                        name="information_security_policy"
                                                        value={values.information_security_policy}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        label="Findings"
                                                        disabled={false}
                                                        required={true}
                                                    />
                                                </td>
                                                <td className="border border-slate-300">
                                                    <SelectFieldIcon 
                                                    name="information_security_policy_comment"
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    value={values.information_security_policy_comment}
                                                    label="Action"
                                                    required={true}
                                                    disabled={false}
                                                    options={[ 
                                                        { id: 1, value: "Pass", label: "Pass" }, { id: 2, value: "Fail", label: "Fail"}
                                                    ]}
                                                    />
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="border border-slate-300">
                                                    Data protection and privacy policy
                                                </td>
                                                <td className="border border-slate-300">
                                                    <TextAreaIcon
                                                        rows={6}
                                                        cols={5}
                                                        name="data_protection_and_privacy"
                                                        value={values.data_protection_and_privacy}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        label="Findings"
                                                        disabled={false}
                                                        required={true}
                                                    />
                                                </td>
                                                <td className="border border-slate-300">
                                                    <SelectFieldIcon 
                                                    name="data_protection_and_privacy_comment"
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    value={values.data_protection_and_privacy_comment}
                                                    label="Action"
                                                    required={true}
                                                    disabled={false}
                                                    options={[ 
                                                        { id: 1, value: "Pass", label: "Pass" }, { id: 2, value: "Fail", label: "Fail"}
                                                    ]}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <SelectFieldIcon 
                                        name="action"
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        value={values.action}
                                        label="Action"
                                        required={true}
                                        disabled={comments[ 0 ]?.action ? true : false}
                                        options={[ 
                                            { id: 1, value: "Approval", label: "Recommend for Approval" },
                                            { id: 2, value: "Rejection", label: "Recommend for Rejection"}
                                        ]}
                                        question="Next Course of Action" />
                                </div>

                                {circularLoading ? (
                                    <div className="flex items-center justify-center">
                                        <CircularProgress size={24} color="primary" />
                                    </div>
                                ):
                                ( 
                                    <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                        {`Submit`}
                                    </button>
                                )}
                            </form>
                        )
                    }  }
                </Formik>
            </div>
            </Panel>
        )
    }

    if( localStorage.getItem( "role" )?.toUpperCase().includes("QA1") && localStorage.getItem( "application_action" )?.toUpperCase() === "QA1" ) {
        return (
            <Panel label="Quality Assurance Level 1">
                <div className="flex flex-col items-start justify-center px-5 py-2">
            {/* <h2>{`Document Verification`}</h2> */}
            <Formik initialValues={{
                action: comments[ 0 ]?.action || "",
                deferred_to_level: "",
                actioned_by: localStorage.getItem( "username" ),
                comments: comments[ 0 ]?.comments || "",
                level_of_certification_compliance: qa1Report?.level_of_certification_compliance,
                level_of_certification_remarks: qa1Report?.level_of_certification_remarks,
                audit_report_on_file: qa1Report?.audit_report_on_file,
                required_documents_compliance: qa1Report?.required_documents_compliance,
                required_documents_remarks: qa1Report?.required_documents_remarks,
                audit_report_complete_compliance: qa1Report?.audit_report_complete_compliance,
                audit_report_complete_remarks: qa1Report?.audit_report_complete_remarks,
                payment_of_fees_compliance: qa1Report?.payment_of_fees_compliance,
                payment_of_fees_remarks: qa1Report?.payment_of_fees_remarks,
                domain_applied_for_compliance: qa1Report?.domain_applied_for_compliance,
                domain_applied_for_remarks: qa1Report?.domain_applied_for_remarks,
                certification_level_compliance: qa1Report?.certification_level_compliance,
                certification_level_remarks: qa1Report?.certification_level_remarks,
                }} onSubmit={handleQAA}>
                { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                    return (
                        <>
                            <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                                <div className="w-full gap-1">
                                    <div className="flex flex-col items-start my-2">
                                        <table className="w-full bg-gray-50 rounded overflow-x-scroll text-gray-700 py-1 text-xs border-collapse mt-5 table-fixed">
                                            <thead className="bg-gray-300">
                                                <tr>
                                                    <td className="border border-slate-300">Checklist Detail</td>
                                                    <td className="border border-slate-300">Remarks /Comments</td>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                <tr>
                                                    <td className="border border-slate-300">Level of certification applied (Should  be same as on the Certificate)</td>
                                                    <td className="border border-slate-300">
                                                        <SelectFieldIcon 
                                                        name="level_of_certification_compliance"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.level_of_certification_compliance}
                                                        label="Compliance"
                                                        required={true}
                                                        disabled={false}
                                                        options={[ 
                                                            { id: 1, value: "compliant", label: "Compliant" },
                                                            { id: 2, value: "non_compliant", label: "Non Compliant"}
                                                        ]}/>

                                                        {values.level_of_certification_compliance === "non_compliant"  && (
                                                            <TextAreaIcon
                                                                rows={6}
                                                                cols={5}
                                                                name="level_of_certification_remarks"
                                                                value={values.level_of_certification_remarks}
                                                                handleChange={handleChange}
                                                                handleBlur={handleBlur}
                                                                label="Remarks/Comment"
                                                                disabled={false}
                                                                required={true}
                                                            />
                                                        ) }
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="border border-slate-300">
                                                        All required documentation are on file
                                                        <div className="mx-2">
                                                            <input type="checkbox" checked="true" readonly="true" name="required_document" value={values.audit_report_on_file} className="border border-gray-300 rounded h-3 w-3" />
                                                            <a href="#" onClick={async () => {
                                                                setShowAuditReport(true)
                                                            } } className="text-xs text-blue-600 decoration-8">
                                                            {` Click to view Audit Report`}
                                                            </a>

                                                            <br/>

                                                            {result?.security_clearance_form == 1 && 
                                                            <>
                                                                <input type="checkbox" checked="true" readonly="true" name="required_document" value={true} className="border border-gray-300 rounded h-3 w-3" />
                                                                <a href="#" onClick={async () => {
                                                                    setShowSecurityClearanceReport(true)
                                                                } } className="text-xs text-blue-600 decoration-8">
                                                                {` Click to view Security Report`}
                                                            </a>
                                                            </>
                                                            }

                                                            {files?.map( ( item, index ) => {
                                                                return (
                                                                    <div>
                                                                        <input type="checkbox" checked="true" readonly="true" name="required_document" className="border border-gray-300 rounded h-3 w-3" />
                                                                        <a className="text-xs text-blue-600 cursor-pointer" ref={ref} id={item.id} onClick={previewFile}> {item.name}_{index+1}</a>
                                                                    </div>
                                                                )
                                                            } )}
                                                        </div> 
                                                    </td>
                                                    <td className="border border-slate-300">
                                                        <SelectFieldIcon 
                                                            name="required_documents_compliance"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.required_documents_compliance}
                                                            label="Compliance"
                                                            required={true}
                                                            disabled={false}
                                                            options={[ 
                                                                { id: 1, value: "compliant", label: "Compliant" },
                                                                { id: 2, value: "non_compliant", label: "Non Compliant"}
                                                            ]}/>

                                                        {values.required_documents_compliance === "non_compliant"  && (
                                                            <TextAreaIcon
                                                                rows={6}
                                                                cols={5}
                                                                name="required_documents_remarks"
                                                                value={values.required_documents_remarks}
                                                                handleChange={handleChange}
                                                                handleBlur={handleBlur}
                                                                label="Remarks/Comment"
                                                                disabled={false}
                                                                required={true}
                                                            />
                                                        )}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="border border-slate-300">Audit report complete in alignment with the IT Certification requirements</td>
                                                    <td className="border border-slate-300">
                                                        <SelectFieldIcon 
                                                        name="audit_report_complete_compliance"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.audit_report_complete_compliance}
                                                        label="Compliance"
                                                        required={true}
                                                        disabled={false}
                                                        options={[ 
                                                            { id: 1, value: "compliant", label: "Compliant" },
                                                            { id: 2, value: "non_compliant", label: "Non Compliant"}
                                                        ]}/>

                                                        {values.audit_report_complete_compliance === "non_compliant"  && (
                                                            <TextAreaIcon
                                                                rows={6}
                                                                cols={5}
                                                                name="audit_report_complete_remarks"
                                                                value={values.audit_report_complete_remarks}
                                                                handleChange={handleChange}
                                                                handleBlur={handleBlur}
                                                                label="Remarks/Comment"
                                                                disabled={false}
                                                                required={true}
                                                            />
                                                        )}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="border border-slate-300">Payment of the required fees made</td>
                                                    <td className="border border-slate-300">
                                                        <SelectFieldIcon 
                                                            name="payment_of_fees_compliance"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.payment_of_fees_compliance}
                                                            label="Compliance"
                                                            required={true}
                                                            disabled={false}
                                                            options={[ 
                                                                { id: 1, value: "compliant", label: "Compliant" },
                                                                { id: 2, value: "non_compliant", label: "Non Compliant"}
                                                            ]}/>

                                                        {values.payment_of_fees_compliance === "non_compliant"  && (
                                                            <TextAreaIcon
                                                                rows={6}
                                                                cols={5}
                                                                name="payment_of_fees_remarks"
                                                                value={values.payment_of_fees_remarks}
                                                                handleChange={handleChange}
                                                                handleBlur={handleBlur}
                                                                label="Remarks/Comment"
                                                                disabled={false}
                                                                required={true}
                                                            />
                                                        )}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="border border-slate-300">Domain applied for in line with Company Competence</td>
                                                    <td className="border border-slate-300">
                                                        <SelectFieldIcon 
                                                            name="domain_applied_for_compliance"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.domain_applied_for_compliance}
                                                            label="Compliance"
                                                            required={true}
                                                            disabled={false}
                                                            options={[ 
                                                                { id: 1, value: "compliant", label: "Compliant" },
                                                                { id: 2, value: "non_compliant", label: "Non Compliant"}
                                                            ]}/>

                                                        {values.domain_applied_for_compliance === "non_compliant"  && (
                                                            <TextAreaIcon
                                                                rows={6}
                                                                cols={5}
                                                                name="domain_applied_for_remarks"
                                                                value={values.domain_applied_for_remarks}
                                                                handleChange={handleChange}
                                                                handleBlur={handleBlur}
                                                                label="Remarks/Comment"
                                                                disabled={false}
                                                                required={true}
                                                            />
                                                        )}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="border border-slate-300">Certification level</td>
                                                    <td className="border border-slate-300">
                                                        <SelectFieldIcon 
                                                            name="certification_level_compliance"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.certification_level_compliance}
                                                            label="Compliance"
                                                            required={true}
                                                            disabled={false}
                                                            options={[ 
                                                                { id: 1, value: "compliant", label: "Compliant" },
                                                                { id: 2, value: "non_compliant", label: "Non Compliant"}
                                                            ]}/>

                                                        {values.certification_level_compliance === "non_compliant"  && (
                                                            <TextAreaIcon
                                                                rows={6}
                                                                cols={5}
                                                                name="certification_level_remarks"
                                                                value={values.certification_level_remarks}
                                                                handleChange={handleChange}
                                                                handleBlur={handleBlur}
                                                                label="Remarks/Comment"
                                                                disabled={false}
                                                                required={true}
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="flex flex-col items-start">
                                        <SelectFieldIcon 
                                            name="action"
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            value={values.action}
                                            label="Action"
                                            required={true}
                                            disabled={false}
                                            options={[ 
                                                { id: 1, value: "Approval", label: "Recommend for Approval(QA2)" },
                                                { id: 2, value: "Rejection", label: "Recommend for Rejection"},
                                                { id: 3, value: "Defer", label: "Defer"},
                                                { id: 4, value: "forward_to_qa3", label: "Forward QA3"}
                                            ]}
                                            question="Next Course of Action" 
                                        />

                                        {values.action === 'Defer' && (
                                            <SelectFieldIcon 
                                                name="deferred_to_level"
                                                handleChange={handleChange}
                                                handleBlur={handleBlur}
                                                value={values.deferred_to_level}
                                                label="Deferred To"
                                                required={true}
                                                disabled={comments[ 0 ]?.deferred_to_level ? true : false}
                                                options={[ 
                                                    { id: 1, value: "AUDITOR", label: "AUDITOR" },
                                                    { id: 2, value: "QA1", label: "QA1"},
                                                    { id: 3, value: "QA2", label: "QA2"},
                                                    { id: 3, value: "QA3", label: "QA3"}
                                                ]}
                                                question="Defer to ?" 
                                            />
                                        )}

                                        <TextAreaIcon
                                            rows={3}
                                            cols={90}
                                            name="comments"
                                            value={values.comments}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            label="Comments"
                                            disabled={false}
                                            question={`Add any comments/remarks`}
                                            required={true}
                                        />

                                        {circularLoading ? (
                                            <div className="flex items-center justify-center">
                                                <CircularProgress size={24} color="primary" />
                                            </div>
                                        ):
                                        (
                                            <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                                {`Submit`}
                                            </button>
                                        )
                                        }
                                    </div>

                                    
                                </div>

                                {/* {circularLoading ? (
                                    <div className="flex items-center justify-center">
                                        <CircularProgress size={24} color="primary" />
                                    </div>
                                ):
                                ( 
                                    ! ( comments[ 0 ]?.action ) && 
                                    ( <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                        {`Submit`}
                                    </button>  )
                                )}  */}
                            </form>
                            <ModalComponent title={`Audit Report`} open={showAuditReport}>
                                <div className="flex flex-col items-center justify-center">
                                <table className="text-gray-700 py-1 text-xs border-collapse mt-2 table-fixed overflow-x-scroll">
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Type of Audit</th>
                                    <td className="border border-slate-300">{auditReport?.type_of_audit}</td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Applicable Regulation</th>
                                    <td className="border border-slate-300">{auditReport?.applicable_regulation || "NITA-U (Certification of Providers of IT Products and Services) (Amendment) Regulation 2018"}</td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Applicable Standard(s)</th>
                                    <td className="border border-slate-300">{auditReport?.applicable_standard}</td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">ISIC Codes</th>
                                    <td className="border border-slate-300">{auditReport?.isic_codes}</td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Audit Site</th>
                                    <td className="border border-slate-300">{auditReport?.audit_site}</td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Audit Date</th>
                                    <td className="border border-slate-300">{auditReport?.audit_date}</td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Distribution/Confidentiality/Rights of <br/>bownership/Limitations/Responsibilities</th>
                                    <td className="border border-slate-300">{auditReport?.distribution_limitations_responsibilties}</td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Audit Criteria</th>
                                    <td className="border border-slate-300">{auditReport?.audit_criteria}</td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Proof of Legal Status</th>
                                    <td className="border border-slate-300">
                                        {auditReport?.proof_of_legal_status}<br/>
                                        - <b>{auditReport?.proof_of_legal_status_comment}</b>
                                    </td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Proof of registration for <br/>tax purposes</th>
                                    <td className="border border-slate-300">
                                        {auditReport?.proof_of_registration}<br/>
                                        - <b>{auditReport?.proof_of_registration_comment}</b>
                                    </td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Proof of Office location and <br/>necessary facilities, equipment <br/>and infrastructure</th>
                                    <td className="border border-slate-300">
                                        {auditReport?.proof_of_office_location}<br/>
                                        - <b>{auditReport?.proof_of_office_location_comment}</b>
                                    </td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Proof of IT Personnel used to <br/>provide IT Services</th>
                                    <td className="border border-slate-300">
                                        {auditReport?.proof_of_it_personnel}<br/>
                                        - <b>{auditReport?.proof_of_it_personnel_comment}</b>
                                    </td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Proof of applicable quality<br/> and technical manuals</th>
                                    <td className="border border-slate-300">
                                        {auditReport?.proof_of_manuals}<br/>
                                        - <b>{auditReport?.proof_of_manuals_comment}</b>
                                    </td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Proof of satisfactory past services<br/> provided in the field of IT service/product<br/> for which certification is sought</th>
                                    <td className="border border-slate-300">
                                        {auditReport?.proof_of_past_services}<br/>
                                        - <b>{auditReport?.proof_of_past_services_comment}</b>
                                    </td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Audit Notes</th>
                                    <td className="border border-slate-300">{auditReport?.audit_notes} </td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Auditee Members</th>
                                    <td className="border border-slate-300">{auditReport?.auditee_members} </td>
                                    </tr>
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Report added on</th>
                                    <td className="border border-slate-300">{moment( auditReport?.created_at ).format("DD MMM, YYYY")}</td>
                                    </tr>
                                </table>
                                
                                <button onClick={async () => {
                                    setShowAuditReport(false)
                                    } } className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
                                    Close
                                </button>
                                </div>
                            </ModalComponent>

                            <ModalComponent title={`Security Clearance Report`} open={showSecurityClearanceReport}>
                                <div className="flex flex-col items-center justify-center">
                                <table className="text-gray-700 py-1 text-xs border-collapse mt-2 table-fixed overflow-x-scroll">
                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Code of conduct (for your staff) detailing written collection of the rules, principles, values and employee expectations, behavior, and relationships that the organization considers significant and believes are fundamental to its successful operations</th>
                                    <td className="border border-slate-300">{securityReport?.code_of_conduct}</td>
                                    <td className="border border-slate-300">{securityReport?.code_of_conduct_comment}</td>
                                    </tr>

                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Terms or conditions of agreement, including any guarantees, that apply to your systems</th>
                                    <td className="border border-slate-300">{securityReport?.terms_of_conditions_of_agreement}</td>
                                    <td className="border border-slate-300">{securityReport?.terms_of_conditions_of_agreement_comment}</td>
                                    </tr>

                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Code of Staff confidentiality & non-disclosure agreements</th>
                                    <td className="border border-slate-300">{securityReport?.staff_confidentiality_and_non_disclosure}</td>
                                    <td className="border border-slate-300">{securityReport?.staff_confidentiality_and_non_disclosure_comment}</td>
                                    </tr>

                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Data retention mechanism/policy</th>
                                    <td className="border border-slate-300">{securityReport?.data_retention_mechanism}</td>
                                    <td className="border border-slate-300">{securityReport?.data_retention_mechanism_comment}</td>
                                    </tr>

                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Internal information security awareness for staff</th>
                                    <td className="border border-slate-300">{securityReport?.internal_information_security_awareness}</td>
                                    <td className="border border-slate-300">{securityReport?.internal_information_security_awareness_comment}</td>
                                    </tr>

                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Information Security policy</th>
                                    <td className="border border-slate-300">{securityReport?.information_security_policy}</td>
                                    <td className="border border-slate-300">{securityReport?.information_security_policy_comment}</td>
                                    </tr>

                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Data protection and privacy policy</th>
                                    <td className="border border-slate-300">{securityReport?.data_protection_and_privacy}</td>
                                    <td className="border border-slate-300">{securityReport?.data_protection_and_privacy_comment}</td>
                                    </tr>

                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Action</th>
                                    <td className="border border-slate-300" colSpan={2}>{securityReport?.action}</td>
                                    </tr>

                                    <tr className="text-xs p-2 text-left">
                                    <th className="border border-slate-300 p-1">Actioned By</th>
                                    <td className="border border-slate-300" colSpan={2}>{securityReport?.created_by}</td>
                                    </tr>
                                </table>

                                <button onClick={async () => {
                                    setShowSecurityClearanceReport(false)
                                    } } className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
                                    Close
                                </button>
                                </div>
                            </ModalComponent>
                        </>
                    )
                }  }
            </Formik>
            </div>
            </Panel>
        )
    }

    if( localStorage.getItem( "role" )?.toUpperCase().includes("QA2") && localStorage.getItem( "application_action" )?.toUpperCase() === "QA2" ) {
        return (
            <Panel label="Quality Assurance Level 2">
                <div className="flex flex-col items-start justify-center px-5 py-2">
            {/* <h2>{`Document Verification`}</h2> */}
            <Formik initialValues={{
                action: comments[ 0 ]?.action || "",
                deferred_to_level: "",
                actioned_by: localStorage.getItem( "username" ),
                comments: comments[ 0 ]?.comments || ""
                }} onSubmit={handleQAA}>
                { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                    return (
                        <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                            <div className="w-full grid grid-rows-2 gap-1">
                                <SelectFieldIcon 
                                    name="action"
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    value={values.action}
                                    label="Action"
                                    required={true}
                                    disabled={comments[ 0 ]?.action ? true : false}
                                    options={[ 
                                        { id: 1, value: "Approval", label: "Recommend for Approval(QA3)" },
                                        { id: 2, value: "Rejection", label: "Recommend for Rejection"},
                                        { id: 3, value: "Defer", label: "Defer"}
                                    ]}
                                    question="Next Course of Action" 
                                />

                                {values.action === 'Defer' && (
                                    <SelectFieldIcon 
                                        name="deferred_to_level"
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        value={values.deferred_to_level}
                                        label="Deferred To"
                                        required={true}
                                        disabled={comments[ 0 ]?.deferred_to_level ? true : false}
                                        options={[ 
                                            { id: 1, value: "AUDITOR", label: "AUDITOR" },
                                            { id: 2, value: "QA1", label: "QA1"},
                                            { id: 3, value: "QA2", label: "QA2"},
                                            { id: 3, value: "QA3", label: "QA3"}
                                        ]}
                                        question="Defer to ?" 
                                    />
                                )}

                                <TextAreaIcon
                                    rows={3}
                                    cols={5}
                                    name="comments"
                                    value={values.comments}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    label="Comments"
                                    disabled={comments[ 0 ]?.action ? true : false}
                                    question={`Add any comments/remarks`}
                                    required={true}
                                />
                            </div>

                            {circularLoading ? (
                                <div className="flex items-center justify-center">
                                    <CircularProgress size={24} color="primary" />
                                </div>
                            ):
                            ( 
                                ! ( comments[ 0 ]?.action ) && 
                                ( <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                    {`Submit`}
                                </button> )
                            )}
                        </form>
                    )
                }  }
            </Formik>
            </div>
            </Panel>
        )
    }

    if( localStorage.getItem( "role" )?.toUpperCase().includes("QA3") && localStorage.getItem( "application_action" )?.toUpperCase() === "QA3" ) {
        return (
            <Panel label="Quality Assurance Level 3">
                <div className="flex flex-col items-start justify-center px-5 py-2">
            {/* <h2>{`Document Verification`}</h2> */}
            <Formik initialValues={{
                action: comments[ 0 ]?.action || "",
                deferred_to_level: "",
                actioned_by: localStorage.getItem( "username" ),
                comments: comments[ 0 ]?.comments || ""
                }} onSubmit={handleQAA}>
                { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                    return (
                        <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                            <div className="w-full grid grid-rows-2 gap-1">
                                <SelectFieldIcon 
                                    name="action"
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    value={values.action}
                                    label="Action"
                                    required={true}
                                    disabled={comments[ 0 ]?.action ? true : false}
                                    options={[ 
                                        { id: 1, value: "Approval", label: "Recommend for Approval" },
                                        { id: 2, value: "Rejection", label: "Recommend for Rejection"},
                                        { id: 3, value: "Defer", label: "Defer"}
                                    ]}
                                    question="Next Course of Action" 
                                />

                                {values.action === 'Defer' && (
                                    <SelectFieldIcon 
                                        name="deferred_to_level"
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        value={values.deferred_to_level}
                                        label="Deferred To"
                                        required={true}
                                        disabled={comments[ 0 ]?.deferred_to_level ? true : false}
                                        options={[ 
                                            { id: 1, value: "AUDITOR", label: "AUDITOR" },
                                            { id: 2, value: "QA1", label: "QA1"},
                                            { id: 3, value: "QA2", label: "QA2"},
                                            { id: 3, value: "QA3", label: "QA3"}
                                        ]}
                                        question="Defer to ?" 
                                    />
                                )}
                                    
                                <TextAreaIcon
                                    rows={3}
                                    cols={5}
                                    name="comments"
                                    value={values.comments}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    label="Comments"
                                    disabled={comments[ 0 ]?.action ? true : false}
                                    question={`Add any comments/remarks`}
                                    required={true}
                                />
                            </div>

                            {circularLoading ? (
                                <div className="flex items-center justify-center">
                                    <CircularProgress size={24} color="primary" />
                                </div>
                            ):
                            ( 
                                ! ( comments[ 0 ]?.action ) && 
                                ( <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                    {`Submit`}
                                </button> )
                            )}
                        </form>
                    )
                }  }
            </Formik>
            </div>
            </Panel>
        )
    }

    if( localStorage.getItem( "role" )?.toUpperCase().includes("APPROVER") && localStorage.getItem( "application_action" )?.toUpperCase() === "APPROVER" ) {
        return (
            <Panel label="Approve I.T Certification License">
                <div className="flex flex-col items-start justify-center px-5 py-2">
                    {/* <h2>{`Document Verification`}</h2> */}
                    <Formik initialValues={{
                        action: comments[ 0 ]?.action || "",
                        actioned_by: localStorage.getItem( "username" ),
                        comments: comments[ 0 ]?.comments || ""
                        }} onSubmit={handleApproval}>
                        { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                            return (
                                <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                                    <div className="w-full grid grid-rows-2 gap-1">
                                        <SelectFieldIcon 
                                            name="action"
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            value={values.action}
                                            label="Action"
                                            required={true}
                                            disabled={comments[ 0 ]?.action ? true : false}
                                            options={[ 
                                                { id: 1, value: "APPROVED", label: "Approve and Sign Certificate" },
                                                { id: 2, value: "REJECTED", label: "Reject" },
                                                { id: 3, value: "DEFERRED", label: "Defer" }
                                            ]}
                                            question="Next Course of Action" />
                                        <TextAreaIcon
                                            rows={3}
                                            cols={5}
                                            name="comments"
                                            value={values.comments}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            label="Comments"
                                            disabled={comments[ 0 ]?.action ? true : false}
                                            question={`Add any comments/remarks`}
                                            required={true}
                                        />
                                    </div>

                                    {circularLoading ? (
                                        <div className="flex items-center justify-center">
                                            <CircularProgress size={24} color="primary" />
                                        </div>
                                    ):
                                    ( 
                                        ! ( comments[ 0 ]?.action ) && 
                                        ( <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                            {`Submit`}
                                        </button> )
                                    )}
                                </form>
                            )
                        }  }
                    </Formik>
                </div>
            </Panel>
        )
    }

    return <div>{`Loading...`}</div>
  
}
